<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <!-- bio -->
        <b-col cols="12">
          <b-form-group :label="$t('Introduction')" label-for="bio-area">
            <p class="border-left-primary border-left-3">
              {{ $t("Self Custody Intro") }}
            </p>

            <p class="border-right-primary border-right-3">
              {{ $t("Self Custody Intro Warning") }}
            </p>
          </b-form-group>
        </b-col>
        <!--/ bio -->
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
// import Cleave from "vue-cleave-component";

// eslint-disable-next-line import/no-extraneous-dependencies
// import "cleave.js/dist/addons/cleave-phone.us";

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BFormTextarea,
    vSelect,
    flatPickr,
    Cleave,
  },
  directives: {
    Ripple,
  },
  props: {},
  data() {
    return {};
  },
  methods: {
    resetForm() {},
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
